package ui.campaign.detailv2.editor.wrapper

import api.ResourceType
import common.frontend.api.Io
import org.ssoft.common.type.ScreenRatio
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.layer_top_detail_editor__err_visual_duration
import tools.EFieldRegularInt
import tools.await

class CampaignWrapperEVisualDynamic(
    companyId: Long,
    campaign: Io.Campaign,
    devicesScreenRatio: () -> List<ScreenRatio>
) : ImplCampaignWrapperEVisual(
    companyId = companyId,
    campaign = campaign,
    groups = campaign.visuals.filterNot { it.isPrimary },
    devicesScreenRatio = devicesScreenRatio
) {
    val adapterGroups get() = group

    private val deviceMatch
        get() = adapterGroups.state.map { group ->
            group.visuals.state.filter { it.data.mask in deviceRatioMasks }
        }


    override val err: Boolean
        get() = deviceMatch.any { it.any { it.resource != null && it.invalidVisualDuration } }

    override suspend fun extractErr(): String? {
        return if (!err) null
        else Res.string.layer_top_detail_editor__err_visual_duration.await()
    }

    fun createGroup() {
        adapterGroups.add(0, Io.Campaign.VisualGroup.EMPTY)
    }

    override fun extract(): List<Io.Campaign.VisualGroup> {
        return adapterGroups.state.map { group ->
            group.data.conditions.weather.pictogram.enable = group.data.conditions.weather.pictogram.id.isNotEmpty()
            group.visuals.state.filter { it.data.mask in deviceRatioMasks }
                .mapNotNull { it.resource }
                .onEach {
                    if (ResourceType.IMAGE match it.type) {
                        it.duration = campaign.settings.campaignDuration
                    }
                }.let { resources ->
                    group.data.copy(
                        res = resources.toMutableList()
                    )
                }
        }.filter { it.res.isNotEmpty() }
    }

    val visualRotaryMode = EFieldRegularInt(
        property = campaign::visualRotaryMode
    )


}
